import React from "react";

const ResetPassword = props => {
    return (
        <div className="island">
            <form onSubmit={props.submit}>
                <div className="form-item form-type-textfield form-item-name">
                    <label htmlFor="edit-name">
                        Username or e-mail address{" "}
                        <span
                            className="form-required"
                            title="This field is required."
                        >
                            *
                        </span>
                    </label>
                    <input
                        type="text"
                        id="email"
                        onChange={props.change}
                        name="email"
                        className="form-text"
                    />
                </div>
                <div className="form-item form-type-textfield form-item-name">
                    <label htmlFor="edit-name">
                        New Passsword
                        <span
                            className="form-required"
                            title="This field is required."
                        >
                            *
                        </span>
                    </label>
                    <input
                        type="password"
                        id="password"
                        onChange={props.change}
                        name="password"
                        className="form-text"
                    />
                </div>
                <div className="form-item form-type-textfield form-item-name">
                    <label htmlFor="edit-name">
                        Confirm Password
                        <span
                            className="form-required"
                            title="This field is required."
                        >
                            *
                        </span>
                    </label>
                    <input
                        type="password"
                        id="password_confirmation"
                        onChange={props.change}
                        name="password_confirmation"
                        className="form-text"
                    />
                </div>
                <div className="form-actions form-wrapper" id="edit-actions">
                    <input
                        type="submit"
                        id="edit-submit"
                        name="op"
                        value="Submit"
                        className="form-submit"
                    />
                </div>
            </form>

            <hr />

            <a className="" href="/forgotpassword">
                Forgot your password?
            </a>
        </div>
    );
};

export default ResetPassword;
